/**
 * 学习的课程章节信息
 */
class LearningCourseChapter {
  /**
   * 课程章节编号
   */
  id = ''
  /**
   * 课程章节名称
   */
  name = ''
  /**
   * 章节父节点编号
   */
  parentId = ''
}

export default LearningCourseChapter
